import type { FC } from 'react';
import React, { useMemo } from 'react';

import StarFilledIcon from '@atlaskit/icon/core/star-starred';
import { token, useThemeObserver } from '@atlaskit/tokens';

type Size = 'small' | 'medium';

type IconSpacing = 'none' | 'spacious';

type StarIconProps = {
	label: string;
	size?: Size;
	testId?: string;
	spacing?: IconSpacing;
};

export const StarSelectedIcon: FC<StarIconProps> = ({ label, size, testId, spacing }) => {
	const theme = useThemeObserver();
	const primaryColor = useMemo(() => {
		return theme.colorMode === 'dark'
			? token('color.icon.accent.yellow')
			: token('color.icon.accent.orange');
	}, [theme.colorMode]);

	return (
		<StarFilledIcon
			label={label}
			color={primaryColor}
			{...(size && { size })}
			{...(testId && { testId })}
			spacing={spacing}
		/>
	);
};
